/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Old/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import CreditCards from './CreditCards/index'
import Data from './Data/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import GenerateAction from './GenerateAction/index'
import Locations from './Locations/index'
import MinDueAmount from './MinDueAmount/index'
import Overdue from './Overdue/index'
import React from 'react'
import ToggleVersionAction from './ToggleVersionAction/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Old({
  children,
  viewPath = "/App/Account/Content/Financial/Content/Statements/Old"
  
}) {
let selectedQueryVersionValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'query.version',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<div
  data-testid="Old.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Old.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Data
  viewPath={`${viewPath}/Data`}
 data="selected.query.version"
 key={selectedQueryVersionValueData}
/>
</div>
<div
  data-testid="Old.Vertical:1"
  data-view-path={viewPath}
 style={{'--pl-1-lk6': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-lk6': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--blc-3-lk6': dtColorsNeutral400}}
 className={`views-block ${styles.Vertical1}`}
>
<ToggleVersionAction
  viewPath={`${viewPath}/ToggleVersionAction`}
/>
<Locations
  viewPath={`${viewPath}/Locations`}
/>
<Overdue
  viewPath={`${viewPath}/Overdue`}
/>
<MinDueAmount
  viewPath={`${viewPath}/MinDueAmount`}
/>
<GenerateAction
  viewPath={`${viewPath}/GenerateAction`}
/>
<CreditCards
  viewPath={`${viewPath}/CreditCards`}
/>
</div>
</div>
{children}
</React.Fragment>)
}